import initialState from './initialState';
import { reducer as loadCollectionsReducer } from './loadCollections';
import { reducer as deleteSourceConnectorReducer } from './deleteSourceConnector';
import { reducer as refreshSourceDataReducer } from './refreshSourceData';
import { reducer as getDataEditReducer } from './getDataEdit';
import { reducer as getExternalDataBaseReducer } from './getExternalDataBase';
import { reducer as loadAppwriteExternaldbReducer } from './loadAppwriteExternaldb';
import { reducer as collectionListExternaldbsReducer } from './collectionListExternaldbs';
import { reducer as xanoUpdateCollectionReducer } from './xanoUpdateCollection';
import { reducer as xanoDataBaseTableReducer } from './xanoDataBaseTable';
import { reducer as getXanoTableReducer } from './getXanoTable';
import { reducer as saveDataInExternalDbReducer } from './saveDataInExternalDb';
import { reducer as getStoredXanoDataReducer } from './getStoredXanoData';
import { reducer as xanoSchemaReducer } from './xanoSchema';
import { reducer as createCollectionfromXanoReducer } from './createCollectionfromXano';
import { reducer as saveXanoFieldsReducer } from './saveXanoFields';
import { reducer as loadAppwriteCollectionDetailsReducer } from './loadAppwriteCollectionDetails';
import { reducer as appwriteCollectionUpdateReducer } from './appwriteCollectionUpdate';
import { reducer as getDatabasesForAppwriteReducer } from './getDatabasesForAppwrite';
import { reducer as getCollectionsByAppwriteReducer } from './getCollectionsByAppwrite';
import { reducer as saveDataInExternaldatabaseReducer } from './saveDataInExternaldatabase';
import { reducer as loadExternalDatabaseReducer } from './loadExternalDatabase';
import { reducer as createCollectionWithAppwriteReducer } from './createCollectionWithAppwrite';
import { reducer as appwriteUpdateExternalDatabaseReducer } from './appwriteUpdateExternalDatabase';
import { reducer as getSupabaseDataReducer } from './getSupabaseData';
import { reducer as saveSupabaseDataInExternalDbReducer } from './saveSupabaseDataInExternalDb';
import { reducer as createCollectionfromSupabaseReducer } from './createCollectionfromSupabase';
import { reducer as getSupabaseExternalDbReducer } from './getSupabaseExternalDb';
import { reducer as updateSupabaseExternalDbReducer } from './updateSupabaseExternalDb';
import { reducer as supabaseUpdateCollectionReducer } from './supabaseUpdateCollection';
import { reducer as xataWorkspaceListReducer } from './xataWorkspaceList';
import { reducer as getDatabasesForXataReducer } from './getDatabasesForXata';
import { reducer as xataSaveExternalDatabaseReducer } from './xataSaveExternalDatabase';
import { reducer as loadExternalDatabaseForXataReducer } from './loadExternalDatabaseForXata';
import { reducer as getSchemaForXataCollectionReducer } from './getSchemaForXataCollection';
import { reducer as updateTableAndFieldsForXataReducer } from './updateTableAndFieldsForXata';
import { reducer as createCollectionWithXataReducer } from './createCollectionWithXata';
import { reducer as updateCollectionWithXataReducer } from './updateCollectionWithXata';
import { reducer as getCollectionsForDirectusReducer } from './getCollectionsForDirectus';
import { reducer as saveExternaldatabaseForDirectusReducer } from './saveExternaldatabaseForDirectus';
import { reducer as loadExternalDatabaseForDirectusReducer } from './loadExternalDatabaseForDirectus';
import { reducer as getSchemaForDirectusCollectionReducer } from './getSchemaForDirectusCollection';
import { reducer as createCollectionWithDirectusReducer } from './createCollectionWithDirectus';
import { reducer as updateExternalDatabaseForDirectusReducer } from './updateExternalDatabaseForDirectus';
import { reducer as updateCollectionForDirectusReducer } from './updateCollectionForDirectus';
import { reducer as deleteExternalDatabaseReducer } from './deleteExternalDatabase';
import { reducer as airtableWorkspaceListReducer } from './airtableWorkspaceList';
import { reducer as airtableGetTablesReducer } from './airtableGetTables';
import { reducer as saveExternaldatabaseForAirtableReducer } from './saveExternaldatabaseForAirtable';
import { reducer as loadExternalDatabaseForAirtableReducer } from './loadExternalDatabaseForAirtable';
import { reducer as createCollectionWithAirtableReducer } from './createCollectionWithAirtable';
import { reducer as airtableUpdateExternalDatabaseReducer } from './airtableUpdateExternalDatabase';
import { reducer as updateCollectionForAirtableReducer } from './updateCollectionForAirtable';
import { reducer as getXanoInstanceReducer } from './getXanoInstance';
import { reducer as xanoTokenUrlReducer } from './xanoTokenUrl';
import { reducer as getXanoApiGroupsReducer } from './getXanoApiGroups';
import { reducer as getCollectionsForSalesforceReducer } from './getCollectionsForSalesforce';
import { reducer as loadExternalDatabaseForSalesforceReducer } from './loadExternalDatabaseForSalesforce';
import { reducer as getSchemaForSalesforceCollectionReducer } from './getSchemaForSalesforceCollection';
import { reducer as createCollectionWithSalesforceReducer } from './createCollectionWithSalesforce';
import { reducer as saveExternaldatabaseForSalesforceReducer } from './saveExternaldatabaseForSalesforce';
import { reducer as updateExternaldatabaseForSalesforceReducer } from './updateExternaldatabaseForSalesforce';
import { reducer as updateCollectionForSalesforceReducer } from './updateCollectionForSalesforce';
import { reducer as loadProjectExternalDbCollectionsReducer } from './loadProjectExternalDbCollections';
import { reducer as loadEventsExternalDataSourceReducer } from './loadEventsExternalDataSource';
import { reducer as loadExternalApisExternalDbReducer } from './loadExternalApisExternalDb';
import { reducer as updateTablesAndFieldsReducer } from './updateTablesAndFields';
import { reducer as supabaseEnvironmentVariablesReducer } from './supabaseEnvironmentVariables';
import { reducer as updateTablesAndFieldsAppwriteReducer } from './updateTablesAndFieldsAppwrite';
import { reducer as appwriteEnvironmentReducer } from './appwriteEnvironment';
import { reducer as updateDirectusTablesReducer } from './updateDirectusTables';
import { reducer as getXanoExternalDbReducer } from './getXanoExternalDb';
import { reducer as createEnvironmentVariablesReducer } from './createEnvironmentVariables';
import { reducer as getPermissionFlagsReducer } from './getPermissionFlags';
const reducers = [
  loadCollectionsReducer,
  deleteSourceConnectorReducer,
  refreshSourceDataReducer,
  getDataEditReducer,
  getExternalDataBaseReducer,
  loadAppwriteExternaldbReducer,
  collectionListExternaldbsReducer,
  xanoUpdateCollectionReducer,
  xanoDataBaseTableReducer,
  getXanoTableReducer,
  saveDataInExternalDbReducer,
  getStoredXanoDataReducer,
  xanoSchemaReducer,
  createCollectionfromXanoReducer,
  saveXanoFieldsReducer,
  loadAppwriteCollectionDetailsReducer,
  appwriteCollectionUpdateReducer,
  getDatabasesForAppwriteReducer,
  getCollectionsByAppwriteReducer,
  saveDataInExternaldatabaseReducer,
  loadExternalDatabaseReducer,
  createCollectionWithAppwriteReducer,
  appwriteUpdateExternalDatabaseReducer,
  getSupabaseDataReducer,
  saveSupabaseDataInExternalDbReducer,
  createCollectionfromSupabaseReducer,
  getSupabaseExternalDbReducer,
  updateSupabaseExternalDbReducer,
  supabaseUpdateCollectionReducer,
  xataWorkspaceListReducer,
  getDatabasesForXataReducer,
  xataSaveExternalDatabaseReducer,
  loadExternalDatabaseForXataReducer,
  getSchemaForXataCollectionReducer,
  updateTableAndFieldsForXataReducer,
  createCollectionWithXataReducer,
  updateCollectionWithXataReducer,
  getCollectionsForDirectusReducer,
  saveExternaldatabaseForDirectusReducer,
  loadExternalDatabaseForDirectusReducer,
  getSchemaForDirectusCollectionReducer,
  createCollectionWithDirectusReducer,
  updateExternalDatabaseForDirectusReducer,
  updateCollectionForDirectusReducer,
  deleteExternalDatabaseReducer,
  airtableWorkspaceListReducer,
  airtableGetTablesReducer,
  saveExternaldatabaseForAirtableReducer,
  loadExternalDatabaseForAirtableReducer,
  createCollectionWithAirtableReducer,
  airtableUpdateExternalDatabaseReducer,
  updateCollectionForAirtableReducer,
  getXanoInstanceReducer,
  xanoTokenUrlReducer,
  getXanoApiGroupsReducer,
  getCollectionsForSalesforceReducer,
  loadExternalDatabaseForSalesforceReducer,
  getSchemaForSalesforceCollectionReducer,
  createCollectionWithSalesforceReducer,
  saveExternaldatabaseForSalesforceReducer,
  updateExternaldatabaseForSalesforceReducer,
  updateCollectionForSalesforceReducer,
  loadProjectExternalDbCollectionsReducer,
  loadEventsExternalDataSourceReducer,
  loadExternalApisExternalDbReducer,
  updateTablesAndFieldsReducer,
  supabaseEnvironmentVariablesReducer,
  updateTablesAndFieldsAppwriteReducer,
  appwriteEnvironmentReducer,
  updateDirectusTablesReducer,
  getXanoExternalDbReducer,
  createEnvironmentVariablesReducer,
  getPermissionFlagsReducer,
];

export default function reducer(state = initialState, action) {
  let newState;
  switch (action.type) {
    default:
      newState = state;
      break;
  }
  return reducers.reduce((s, r) => r(s, action), newState);
}
